<template>
    <div class="notification-toaster">
        <Toast
            v-for="(notification, notificationId) of notifications"
            :key="notificationId"
            :notification="notification"
            :notificationId="notificationId"
            @onClose="closeNotification"
        />
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import * as types from '../store/actionTypes';
import Toast from './Toast';

export default {
    name: 'NotificationToaster',
    components: {
        Toast
    },
    computed: {
        ...mapState({
            notifications: state => state.notifications.data
        })
    },
    methods: {
        ...mapMutations({
            closeNotification: types.REMOVE_NOTIFICATION
        })
    }
}
</script>
